// Public site additions: header, metadata and page texts rendered on the server.
// Keys are the Arabic source strings (what the Arabic UI shows); values are English.
// Strings that already exist in the prototype catalog (en.ts) need no entry here.
export const webEn: Readonly<Record<string, string>> = {
  'مسار EV | تأجير سيارات تسلا الكهربائية – الجبل الأخضر':
    'Masar EV | Tesla electric car rental – Jebel Akhdar',
  'مسار EV': 'Masar EV',
  'احجز تسلا كهربائية للصعود إلى الجبل الأخضر بدون تكلفة بترول. حجز في دقيقتين وعقد على واتساب.':
    'Book an electric Tesla to drive up Jebel Akhdar with no petrol cost. Book in two minutes, with the contract on WhatsApp.',
  'اصعد الجبل الأخضر': 'Drive up Jebel Akhdar',
  'كيف تحجز': 'How to book',
  'تواصل معنا': 'Contact us',
  القائمة: 'Menu',
  'احجز الآن': 'Book now',
  'إغلاق القائمة': 'Close menu',
  // Landing page
  'افتح في الخرائط': 'Open in Maps',
  'الشحن مشمول': 'Charging included',
  'العقد على واتساب': 'Contract on WhatsApp',
  'تسلا كهربائية بالكامل': 'Fully electric Tesla',
  'تكلفة البترول لرحلتك': 'Petrol cost for your trip',
  تخطي: 'Skip',
  'تعذّر التحقق من التوفر الآن': 'Availability could not be checked right now',
  'نتحقق من السيارات المتاحة…': 'Checking available cars…',
  'سيارة متاحة': 'cars available',
  'تقدير لطريق بركة الموز – سيح قطنة ({km} كم ذهاباً وعودة) مع استهلاك الصعود.':
    'Estimate for the Birkat Al Mouz – Saiq road ({km} km round trip) including the climb.',
  الطريق: 'Road',
  'نقطة التفتيش': 'Checkpoint',
  مفتوح: 'Open',
  بحذر: 'Drive with care',
  مغلق: 'Closed',
  تعمل: 'Open',
  مغلقة: 'Closed',
  // Page not found
  'الصفحة غير موجودة': 'Page not found',
  'خطأ 404': 'Error 404',
  'قد يكون الرابط قديماً أو فيه خطأ. ابدأ من الصفحة الرئيسية أو احجز سيارتك مباشرة.':
    'The link may be old or mistyped. Start from the home page or book your car directly.',
  'الصفحة الرئيسية': 'Home page',
};
